import { Icon as GitBookIcon, type IconName as GitBookIconName } from '@gitbook/icons';
import { createPalette, PaletteCommandType, PalettePositionWidth } from '@gitbook/react-uikit';

import { apiResource, readAPICache } from '../../state';

/**
 * Create a palette to pick a conversations issues cluster.
 */
export function createPickConversationsIssuesClusterPalette({
    organizationId,
    selectedClusterId,
    onPick,
}: {
    organizationId: string;
    selectedClusterId?: string;
    onPick: (clusterId: string) => void;
}) {
    return createPalette({
        search: { placeholder: 'Filter by context' },
        position: {
            width: PalettePositionWidth.LARGE,
        },
        groups: [
            {
                key: 'clusters',
                commands: () => {
                    const { items } = readAPICache(
                        apiResource('listConversationsIssuesClusters', {
                            organizationId,
                        })
                    );

                    return items.map((item) => ({
                        type: PaletteCommandType.RADIO,
                        key: item.id,
                        title: item.label,
                        selected: selectedClusterId === item.id,
                        icon: <GitBookIcon icon={item.icon as GitBookIconName} />,
                        trigger: () => {
                            onPick(item.id);
                        },
                    }));
                },
            },
        ],
    });
}
